<div class="fx-layout-row fx-justify-center fx-align-center fx-fill">
  @if (hasAddress) {
    <div (leafletMapReady)="onMapReady($event)"
         [leafletOptions]="options"
         [ngClass]="getCursorStyle()"
         [ngStyle]="getDimensionOfMap()"
         class="map-widget"
         leaflet>
      <assets-map-makers-control
        id="assets-map-makers-control"
        [controlPosition]="'topleft'"
        [assetMapMarkerGroups]="assetMapMarkerGroups"
        [groupedMarkersEnable]="groupedMarkersEnable"
        [selectedMapMarkerGroup]="currentAssetMapMarkerGroup"
        (slideToggleChange)="toggleClusterMode($event)"
        (radioAssetMapMarkerGroupChange)="applyMapMarkerGroup($event)">
      </assets-map-makers-control>
      <assets-map-legend-control
        #legendControl
        id="assets-map-legend-control"
        [controlPosition]="'bottomright'"
        [mapMarker]="currentAssetMapMarkerGroup.mapMarker">
      </assets-map-legend-control>
      <assets-map-export-control
        id="assets-map-export-control"
        [controlPosition]="'topright'"
        [sidebar]="sidebar"
        [currentLayerName]="currentAssetMapMarkerGroup.name">
      </assets-map-export-control>
    </div>
  } @else {
    <img [src]="appConfig.PLACEHOLDER_MAP" alt="{{ 'LABEL.NO_ASSET_ADDRESS' | translate }}"
         class="default-map-img" />
  }
</div>
